import { Box, EmptyCard } from '@csp/csp-web-ui';
import { FC, useMemo } from 'react';
import { BioSampleContainerItem } from '../../model/BioSampleContainerItem';
import { BioSampleContentService } from '../../service/BioSampleContentService';
import { KitContainerListRow } from './KitContainerListRow';
import { KitContainersListHeader } from './KitContainersListHeader';

type Props = {
  containers: BioSampleContainerItem[];
};
export const KitContainers: FC<Props> = ({ containers }) => {
  const texts = BioSampleContentService.getKitDetailsTexts();
  const rows = useMemo(
    () =>
      containers.map(container => <KitContainerListRow container={container} key={container.sampleContainerCode} />),
    [containers],
  );
  return (
    <Box>
      <KitContainersListHeader />
      {rows}
      {!rows?.length && <EmptyCard title={texts.drawer.body.noContainersFoundForKit.text} />}
    </Box>
  );
};
